module.exports = __webpack_public_path__ + "static/media/colorgame.1801e77a.jpeg";